import { render, staticRenderFns } from "./CkeditorWrapper.vue?vue&type=template&id=352e2715&"
import script from "./CkeditorWrapper.vue?vue&type=script&lang=js&"
export * from "./CkeditorWrapper.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports